<template>
  <Modal class="my-modal" v-model="visible" title="服务信息" :transfer="false" :mask-closable="false" :closable="false" width="900">
    <Form ref="myForm" :model="formData" :label-width="80" class="page-form">
      <FormItem label="商品名称" class="full">
        {{formData.svcName}}
      </FormItem>
      <template v-if="formData.svcCateCode == 'BANK_ACCOUNT'">
        <FormItem label="开户地点" class="full">
          <div class="pie">{{formData.svcAddr}}</div>
        </FormItem>
        <FormItem label="所需资料" class="full">
          <div class="pie">{{formData.svcExtraInfo}}</div>
        </FormItem>
      </template>
      <FormItem label="商品描述" class="full">
        <div v-html="formData.content"></div>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="visible = false">关闭</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      formData: {},
      loading: false
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    async open(data) {
      this.$http({
        url: '/buz/extSvc/detail',
        type: 'GET',
        data: {
          id: data.id
        }
      }).then(res => {
        this.visible = true;
        this.formData = res.data;
      })
    },
    getDetail(id) {
      
    }
  }
};
</script>
<style lang="scss" scoped>
.pie {
  white-space: pre-line;
}
</style>






